import { defineComponent as _defineComponent } from 'vue'
import { loginByPassword, loginBySms, sendCode ,getCSRF} from '@/api/passport/login';
import { useUser } from '@/pinia/modules/userData';
import { message } from 'ant-design-vue';
import { ref, watch } from 'vue';
import storage from 'baimahu/storage';
import { useRouter } from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const LOGIN_TYPE = [
  { id: 1, name: '验证码登录' },
  { id: 2, name: '密码登录' },
];
const login_type = ref(LOGIN_TYPE);
const authCode = ref(60);
const code = ref('');
const router = useRouter();
const md5 = require('blueimp-md5');
const { VUE_APP_EXPIRED: EXPIRED } = process.env;
const { setUserData } = useUser();
const logo = require('@/asset/logo.png');
const bg_img = require('@/asset/img/login-bg.png');
const is_loading = ref(false);
const user = useUser();
const selected_index = ref<number>(1);
function changeLogin_type(id: number) {
  selected_index.value = id;
}
const validateText = ref('');

const mobile = ref('');
const password = ref('');
async function loginAction() {
  let res: any = undefined;
  if (!mobile.value) {
    validateText.value = '请输入手机号';
    return;
  }
  if (!mobile.value || !/^1[0-9]{10}$/.test(String(mobile.value))) {
    validateText.value = '请输入正确的手机号';
    return;
  }
  if (selected_index.value == 1) {
    console.log('验证码');
    if (!code.value) {
      validateText.value = '请输入验证码';
      return;
    }
    is_loading.value = true;
    res = await loginBySms(mobile.value, code.value);
    is_loading.value = false;
  } else {
    if (!password.value) {
      validateText.value = '请输入密码';
      return;
    }
    is_loading.value = true;
    res = await loginByPassword(mobile.value, md5(password.value));
    is_loading.value = false;
  }

  if (!res) {
    message.error('登录失败');
    return;
  }
  if (res.data.is_enable == 2) {
    message.error('账号已被禁用');
    return;
  }
  if (res.status !== 200) {
    message.error(res?.message || '登录失败');
    return;
  }
  message.success('登录成功');
  // const menus = await getMenu();
  // useUser().setMenu(menus);
  storage.setItem('profile', res.data, EXPIRED);
  setUserData(res.data);
  router.push({ path: '/' });
}
function updateInput(value: string) {
  if (value) {
    validateText.value = '';
  }
}
async function sendMessage() {
  if (!mobile.value) {
    validateText.value = '请输入手机号';
    return;
  }
  if (!mobile.value || !/^1[0-9]{10}$/.test(String(mobile.value))) {
    validateText.value = '请输入正确的手机号';
    return;
  }
    // 发送验证码
  authCode.value -= 1
  const timer = setInterval(() => {
    authCode.value -= 1;
    if (authCode.value === 0) {
      clearInterval(timer);
      authCode.value = 60;
    }
  }, 1000);
  const res: any = await sendCode(mobile.value);
  if (res.status !== 200) {
    message.error(res.message);
    return;
  }

}
watch([mobile, password], () => {
  validateText.value = '';
});
getCSRF()

return { __sfc: true,LOGIN_TYPE, login_type, authCode, code, router, md5, EXPIRED, setUserData, logo, bg_img, is_loading, user, selected_index, changeLogin_type, validateText, mobile, password, loginAction, updateInput, sendMessage }
}

})